/**
 * Main Collection Banner Section
 * Handles sidebar sync and description toggle functionality.
 */
(function() {
  /**
   * Syncs all banner layouts with the product grid sidebar state.
   * Adds 'has-sidebar' class when filters sidebar is visible.
   * Supports both native theme filters and Boost Commerce filters.
   */
  function syncBannerLayout() {
    var bannerLayouts = document.querySelectorAll('.collection-banner-layout');

    if (!bannerLayouts.length) return;

    var facetsWrap = document.querySelector('.facets-wrap');
    var boostLayout = document.querySelector('.boost-sd-layout');

    var hasNativeSidebar = facetsWrap && facetsWrap.classList.contains('page-layout-with-sidebar');
    var hasBoostSidebar = boostLayout !== null;
    var hasSidebar = hasNativeSidebar || hasBoostSidebar;

    bannerLayouts.forEach(function(layout) {
      if (hasSidebar) {
        layout.classList.add('has-sidebar');
      } else {
        layout.classList.remove('has-sidebar');
      }
    });
  }

  /**
   * Observes sidebar elements for class changes and Boost content for additions.
   */
  function observeSidebarChanges() {
    var facetsWrap = document.querySelector('.facets-wrap');

    if (facetsWrap) {
      var facetsObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'class') {
            syncBannerLayout();
          }
        });
      });
      facetsObserver.observe(facetsWrap, { attributes: true });
    }

    var boostObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          var boostLayout = document.querySelector('.boost-sd-layout');
          if (boostLayout) {
            syncBannerLayout();
            boostObserver.disconnect();
          }
        }
      });
    });
    boostObserver.observe(document.body, { childList: true, subtree: true });
  }

  /**
   * Initializes the description toggle functionality with animation.
   */
  function initDescriptionToggle() {
    var wrapper = document.querySelector('.collection-description-wrapper');
    if (!wrapper) return;

    var shortDesc = wrapper.querySelector('.collection-description-short');
    var fullDesc = wrapper.querySelector('.collection-description-full');
    var showButton = wrapper.querySelector('.collection-description-toggle[data-action="show"]');
    var hideButton = wrapper.querySelector('.collection-description-toggle[data-action="hide"]');

    if (!shortDesc || !fullDesc) return;

    /**
     * Animates the transition between short and full descriptions.
     * @param {HTMLElement} fromEl - Element to hide
     * @param {HTMLElement} toEl - Element to show
     */
    function animateTransition(fromEl, toEl) {
      var startHeight = wrapper.offsetHeight;
      wrapper.style.height = startHeight + 'px';
      wrapper.style.overflow = 'hidden';

      fromEl.hidden = true;
      toEl.hidden = false;

      var endHeight = toEl.offsetHeight;

      wrapper.offsetHeight;

      wrapper.style.transition = 'height 0.3s ease-in-out';
      wrapper.style.height = endHeight + 'px';

      wrapper.addEventListener('transitionend', function handler() {
        wrapper.style.height = '';
        wrapper.style.overflow = '';
        wrapper.style.transition = '';
        wrapper.removeEventListener('transitionend', handler);
      });
    }

    if (showButton) {
      showButton.addEventListener('click', function() {
        animateTransition(shortDesc, fullDesc);
      });
    }

    if (hideButton) {
      hideButton.addEventListener('click', function() {
        animateTransition(fullDesc, shortDesc);

        wrapper.addEventListener('transitionend', function scrollHandler() {
          wrapper.removeEventListener('transitionend', scrollHandler);
          var section = wrapper.closest('.section-main-collection-banner');
          if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      syncBannerLayout();
      observeSidebarChanges();
      initDescriptionToggle();
    });
  } else {
    syncBannerLayout();
    observeSidebarChanges();
    initDescriptionToggle();
  }
})();
